import React from 'react';

import { useEffect } from 'react';
import { useLandingPageCapabilities } from './useLandingPageCapabilities';
import { useLandingPageActions } from './LandingPageContext';
import SplashSection from './SplashSection';
import WizardsSection from './WizardsSection';

const LandingPage = ({ sharedAssetsPaths }) => {
  useLandingPageCapabilities();
  const { initializeState } = useLandingPageActions();

  useEffect(() => {
    initializeState(sharedAssetsPaths);
  }, []);

  return (
    <>
      <SplashSection />
      <WizardsSection />
    </>
  );
};

export default LandingPage;
